import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { defineEntitySource } from '@/shared/form/entity-source';
import { getCurrentTenant } from '@/shared/http/client';
import type { WalletOption } from '@/modules/wallet/public';

// Filtros da lista declarados uma vez (P01): "Filtrar por" Nome e Código convênio do legado
// (BillingSettingFIlters.tsx:12-44). Arquivo leve: entra no `validateSearch` da rota, então a busca
// de carteira vem da porta de `wallet` por import dinâmico.

const walletPort = () => import('@/modules/wallet/public');

const walletLabel = (item: WalletOption) => `(${String(item.walletCode)}) - ${item.beneficiaryName ?? ''}`;

/**
 * Convênio (`GET /Wallet`, porta F0-min): o legado pedia o código digitado e acumulava chips
 * (`multiple: true`); aqui a pessoa escolhe pelo código ou pelo beneficiário. O fio é o mesmo.
 */
export const walletCodeSource = defineEntitySource<WalletOption>({
  key: ['billing-setting', 'filter', 'wallet'],
  scope: () => getCurrentTenant() ?? null,
  search: async (query, signal) => {
    const port = await walletPort();
    const page = await port.listWalletOptions({ search: query || undefined, tenant: getCurrentTenant() }, signal);
    return page.data;
  },
  byId: async (id, signal) => {
    const port = await walletPort();
    const page = await port.listWalletOptions({ search: id, tenant: getCurrentTenant() }, signal);
    return page.data.find((item) => String(item.walletCode) === id);
  },
  toOption: (item) => ({ value: String(item.walletCode), label: walletLabel(item) }),
});

export const billingSettingFilters = defineFilters([
  { key: 'name', type: 'text', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
  { key: 'walletsCode', type: 'entity', multiple: true, label: msg`Código convênio`, placeholder: msg`Código ou nome do convênio`, source: walletCodeSource },
]);
